module.exports = __webpack_public_path__ + "static/media/Wailord_gaussian2.eb0b13dc.png";